import {Media} from "../types/Products";

export const urlFromMedia = (media: Media): string => (
    media?.url_path
    + (media?.url_path.charAt(media?.url_path?.length - 1) === '/' ? '' : '/')
    + media?.filename
    )
